module.exports = __webpack_public_path__ + "static/media/animated-bente-roller.c533cf56.gif";